import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { PALLET_TYPES } from 'utils/constants/jobDetails';
import { Icon } from '@ontruck/orc';

const LoadToolTip = ({ className, width, length }) => {
  const [show, setShow] = useState(false);
  const handleShow = useCallback(() => {
    setShow(!show);
  }, [show]);

  return (
    <div className={className}>
      <div
        data-testid="load-at-stop__info-button"
        className="load-at-stop__info-button"
        onClick={handleShow}
      >
        <Icon glyph="girded-info" size="1.6rem" />
        {show && (
          <span
            data-testid="load-at-stop__info-tooltip"
            className={`load-at-stop__info-tooltip`}
          >{`${width} cm x ${length} cm`}</span>
        )}
      </div>
    </div>
  );
};

const LoadAtStop = ({ className, loads }) => {
  const loadStrings = loads.map((load, index) => {
    if (load.pallet_type === 'CUSTOM_PALLET') {
      return (
        <div key={`load${index}`} className="load-at-stop__item">
          <span className="load-at-stop__pallet-info load-at-stop__pallet-info--special">
            {`${load.number_of_items} SP`}
            <LoadToolTip
              className={className}
              width={load.item_width}
              length={load.item_length}
            />
          </span>
          <span className="load-at-stop__weight-info">{`${load.total_weight} Kg`}</span>
        </div>
      );
    } else {
      return (
        <div key={`load${index}`} className="load-at-stop__item">
          <span className="load-at-stop__pallet-info">{`${
            load.number_of_items
          } ${PALLET_TYPES[load.pallet_type]}`}</span>
          <span className="load-at-stop__weight-info">{`${load.total_weight} Kg`}</span>
        </div>
      );
    }
  });

  return (
    <div className={className} data-testid="load-at-stop">
      <div className="load-at-stop">{loadStrings}</div>
    </div>
  );
};

LoadAtStop.propTypes = {
  className: PropTypes.string,
  loads: PropTypes.array
};
export default LoadAtStop;
